export default {
	title: 'settings',
	components: [
		{
			title: 'min_charge',
			component: 'min_charge',
		},
		{
			title: 'max_charge',
			component: 'max_charge',
		},
		{
			title: 'output_limit',
			component: 'output_limit',
		},
	],
};
